/* Vienetta görsel indirme (ürün sayfası butonu ve "Görsel İndirme" sayfası ortak kullanır).
   Sitedeki görsel, altına kesilebilir bir bilgi şeridi (barkod, beden tipi, kumaş, seri) eklenerek indirilir;
   büyük beden (battal) ürünlerde görselin sol üstüne "XXL BIG SIZE" rozeti basılır.
   Görseller tarayıcıda işlenir, sunucuya gitmez. */
(function () {
  'use strict';
  if (window.VieGorsel) return;

  var TR = String(document.documentElement.lang || 'tr').slice(0, 2).toLowerCase() === 'tr';
  var M = TR
    ? { barkod: 'BARKOD', beden: 'BEDEN', kumas: 'KUMAŞ', seri: 'SERİ', buyuk: 'BÜYÜK BEDEN', normal: 'NORMAL BEDEN' }
    : { barkod: 'BARCODE', beden: 'SIZE', kumas: 'FABRIC', seri: 'SET', buyuk: 'PLUS SIZE', normal: 'REGULAR SIZE' };
  var ROZET = 'XXL BIG SIZE';
  var ROZET_ZEMIN = '#8B4513';
  var EN_GENIS = 1600;
  var BATTAL_BEDEN = ['1XL', '3XL', '4XL', '5XL', '6XL', '7XL'];

  function sade(s) {
    return String(s == null ? '' : s).replace(/[İIı]/g, 'i').toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
  }

  /** Ürün açıklamasındaki "<strong>Etiket:</strong> değer" satırları -> { 'kumas': 'TAMAMI %100COTTON', ... } */
  function aciklamaAlanlari(html) {
    var out = {};
    var kap = document.createElement('div');
    kap.innerHTML = String(html || '');
    kap.querySelectorAll('strong, b').forEach(function (st) {
      var ad = sade(st.textContent).replace(/:$/, '').trim();
      if (!ad) return;
      var deger = '';
      for (var n = st.nextSibling; n; n = n.nextSibling) {
        if (n.nodeType === 1 && /^(STRONG|B|BR|P|DIV|H\d)$/.test(n.tagName)) break;
        deger += n.textContent || '';
      }
      deger = deger.replace(/\s+/g, ' ').replace(/^[:\s]+/, '').trim();
      if (deger && !out[ad]) out[ad] = deger;
    });
    return out;
  }

  function secenekDegerleri(p, adlar) {
    var ops = p.options || [];
    for (var i = 0; i < ops.length; i++) {
      var ad = sade((ops[i] && ops[i].name) || ops[i]);
      if (adlar.some(function (a) { return ad.indexOf(a) !== -1; })) {
        if (ops[i] && ops[i].values) return ops[i].values.map(String);
        var gorulen = [];
        (p.variants || []).forEach(function (v) { var d = v['option' + (i + 1)]; if (d && gorulen.indexOf(d) === -1) gorulen.push(d); });
        return gorulen;
      }
    }
    return [];
  }

  /** Büyük beden (battal): adında XXL / BATTAL / BIG SIZE / PLUS geçen ya da bedenleri 1XL, 3XL ve üstü olan ürün. */
  function battalMi(p) {
    var baslik = ' ' + String(p.title || '').toUpperCase() + ' ';
    if (/XXL|BATTAL|BIG SIZE| PLUS /.test(baslik)) return true;
    return secenekDegerleri(p, ['beden', 'size']).some(function (b) { return BATTAL_BEDEN.indexOf(String(b).toUpperCase().trim()) !== -1; });
  }

  function urunBilgisi(p) {
    var a = aciklamaAlanlari(p.description);
    var bul = function (adlar) { for (var i = 0; i < adlar.length; i++) if (a[adlar[i]]) return a[adlar[i]]; return ''; };
    return {
      kod: String(p.handle || '').replace(/-r$/i, '').toUpperCase(),
      baslik: p.title || '',
      kumas: bul(['kumas', 'kumas icerigi', 'kumas icerik', 'fabric', 'fabric content', 'kumas cinsi', 'fabric type']),
      seri: bul(['set icerigi', 'set content', 'seri', 'series']),
      battal: battalMi(p)
    };
  }

  var urunOnbellek = {};
  function urunGetir(handle) {
    var h = String(handle || '').trim().toLowerCase();
    if (!h) return Promise.resolve(null);
    if (!urunOnbellek[h]) {
      var kok = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      urunOnbellek[h] = fetch(kok + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return urunOnbellek[h];
  }

  /** Shopify görsel adresi: boyut ekleri atılır, istenen genişlik verilir. */
  function gorselAdresi(src, genislik) {
    var u = String(src || '');
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    try {
      var x = new URL(u, window.location.origin);
      ['width', 'height', 'crop', 'format', 'pad_color'].forEach(function (k) { x.searchParams.delete(k); });
      x.pathname = x.pathname.replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(@\dx)?(\.[a-z0-9]+)$/i, '$3');
      if (genislik) x.searchParams.set('width', String(genislik));
      return x.toString();
    } catch (e) { return u; }
  }

  function dosyaAdi(src) {
    var ad = String(src || '').split('?')[0].split('/').pop() || 'gorsel.jpg';
    return ad.replace(/\.(png|webp|gif|jpeg)$/i, '.jpg').replace(/[^\w.\-]+/g, '_');
  }

  function gorselYukle(url) {
    return fetch(url, { mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.blob();
    }).then(function (blob) {
      return new Promise(function (coz, red) {
        var adres = URL.createObjectURL(blob);
        var im = new Image();
        im.onload = function () { URL.revokeObjectURL(adres); coz(im); };
        im.onerror = function () { URL.revokeObjectURL(adres); red(new Error('görsel çözülemedi')); };
        im.src = adres;
      });
    });
  }

  function yuvarlakKutu(c, x, y, w, h, r) {
    c.beginPath();
    c.moveTo(x + r, y);
    c.arcTo(x + w, y, x + w, y + h, r);
    c.arcTo(x + w, y + h, x, y + h, r);
    c.arcTo(x, y + h, x, y, r);
    c.arcTo(x, y, x + w, y, r);
    c.closePath();
  }

  /**
   * Görseli bilgi şeridiyle birleştirir. bilgi: urunBilgisi() çıktısı.
   * Şerit görselin ALTINDA ayrı bir alandır (kesik çizgiden kesilebilir); rozet görselin üzerindedir.
   */
  function etiketliGorsel(src, bilgi) {
    return gorselYukle(gorselAdresi(src, EN_GENIS)).then(function (im) {
      var W = im.naturalWidth, H = im.naturalHeight;
      var YAZI = 'Arial, Helvetica, sans-serif';
      var bosluk = Math.round(W * 0.035);
      var punto = Math.max(15, Math.round(W / 36));
      var satirH = Math.round(punto * 1.7);
      var kalem = document.createElement('canvas').getContext('2d');

      var kalemler = [[M.barkod, bilgi.kod], [M.beden, bilgi.battal ? M.buyuk : M.normal], [M.kumas, bilgi.kumas], [M.seri, bilgi.seri]]
        .filter(function (k) { return k[1]; });
      var enCok = W - bosluk * 2;
      var olc = function (k, p) {
        kalem.font = 'bold ' + p + 'px ' + YAZI;
        var a = kalem.measureText(k[0] + ': ').width;
        kalem.font = p + 'px ' + YAZI;
        return { ad: a, tum: a + kalem.measureText(k[1]).width };
      };
      // Akış düzeni: kalemler soldan sağa dizilir, sığmayan alt satıra iner; tek başına sığmayan kalem küçültülür
      var satirlar = [[]], x = 0, ara = Math.round(punto * 2.2);
      kalemler.forEach(function (k) {
        var p = punto, o = olc(k, p);
        while (o.tum > enCok && p > 10) { p -= 1; o = olc(k, p); }
        var son = satirlar[satirlar.length - 1];
        if (son.length && x + o.tum > enCok) { son = []; satirlar.push(son); x = 0; }
        son.push({ k: k, p: p, o: o, x: x });
        x += o.tum + ara;
      });
      var seritH = bosluk + satirlar.length * satirH + Math.round(bosluk * 0.6);

      var tuval = document.createElement('canvas');
      tuval.width = W;
      tuval.height = H + seritH;
      var c = tuval.getContext('2d');
      c.fillStyle = '#ffffff';
      c.fillRect(0, 0, W, H + seritH);
      c.drawImage(im, 0, 0, W, H);

      // Kesme çizgisi
      c.strokeStyle = '#9ca3af';
      c.lineWidth = Math.max(1, Math.round(W / 800));
      c.setLineDash([Math.round(W / 90), Math.round(W / 130)]);
      c.beginPath();
      c.moveTo(0, H + c.lineWidth);
      c.lineTo(W, H + c.lineWidth);
      c.stroke();
      c.setLineDash([]);

      c.textBaseline = 'middle';
      satirlar.forEach(function (satir, i) {
        var y = H + bosluk * 0.75 + satirH * i + satirH / 2;
        satir.forEach(function (h) {
          c.fillStyle = '#6b7280';
          c.font = 'bold ' + h.p + 'px ' + YAZI;
          c.fillText(h.k[0] + ': ', bosluk + h.x, y);
          c.fillStyle = '#111111';
          c.font = h.p + 'px ' + YAZI;
          c.fillText(h.k[1], bosluk + h.x + h.o.ad, y);
        });
      });

      if (bilgi.battal) {
        var rp = Math.max(16, Math.round(W / 30));
        c.font = 'bold ' + rp + 'px ' + YAZI;
        var rw = c.measureText(ROZET).width + rp * 1.4, rh = rp * 1.9, rx = Math.round(W * 0.03), ry = Math.round(W * 0.03);
        c.fillStyle = ROZET_ZEMIN;
        yuvarlakKutu(c, rx, ry, rw, rh, Math.round(rp * 0.3));
        c.fill();
        c.fillStyle = '#ffffff';
        c.fillText(ROZET, rx + rp * 0.7, ry + rh / 2 + 1);
      }

      return new Promise(function (coz, red) {
        tuval.toBlob(function (b) { b ? coz(b) : red(new Error('görsel üretilemedi')); }, 'image/jpeg', 0.92);
      });
    });
  }

  function kaydet(blob, ad) {
    var adres = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = adres;
    a.download = ad;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function () { URL.revokeObjectURL(adres); }, 4000);
  }

  var zipBekleyen = null;
  function zipKutuphanesi() {
    if (window.JSZip) return Promise.resolve(window.JSZip);
    if (!zipBekleyen) {
      zipBekleyen = new Promise(function (coz, red) {
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/jszip@3.10.1/dist/jszip.min.js';
        s.onload = function () { coz(window.JSZip); };
        s.onerror = function () { zipBekleyen = null; red(new Error('ZIP kütüphanesi yüklenemedi')); };
        document.head.appendChild(s);
      });
    }
    return zipBekleyen;
  }

  /**
   * Görselleri etiketleyip tek ZIP olarak indirir. isler: [{ src, bilgi, klasor }]; ilerleme(biten, toplam).
   * Döner: { tamam, hata }.
   */
  function zipIndir(isler, zipAdi, ilerleme) {
    return zipKutuphanesi().then(function (JSZip) {
      var zip = new JSZip();
      var sira = 0, biten = 0, hata = 0, adlar = {};
      function isci() {
        if (sira >= isler.length) return Promise.resolve();
        var is = isler[sira++];
        return etiketliGorsel(is.src, is.bilgi).then(function (blob) {
          var ad = (is.klasor ? is.klasor + '/' : '') + dosyaAdi(is.src);
          if (adlar[ad]) ad = ad.replace(/(\.jpg)$/i, '_' + (++adlar[ad]) + '$1'); else adlar[ad] = 1;
          zip.file(ad, blob);
        }).catch(function () { hata++; }).then(function () {
          biten++;
          if (ilerleme) ilerleme(biten, isler.length);
          return isci();
        });
      }
      return Promise.all([isci(), isci(), isci()]).then(function () {
        if (biten - hata === 0) throw new Error(TR ? 'Görseller alınamadı' : 'Images could not be loaded');
        return zip.generateAsync({ type: 'blob' });
      }).then(function (blob) {
        kaydet(blob, zipAdi);
        return { tamam: biten - hata, hata: hata };
      });
    });
  }

  window.VieGorsel = {
    TR: TR,
    urunGetir: urunGetir,
    urunBilgisi: urunBilgisi,
    battalMi: battalMi,
    gorselAdresi: gorselAdresi,
    dosyaAdi: dosyaAdi,
    etiketliGorsel: etiketliGorsel,
    kaydet: kaydet,
    zipIndir: zipIndir
  };
})();
